import type { LoggedEvent } from './types';

// Fast path: rate=1.0 (the default "track everything" deployment) skips both
// Math.random() and the error/success branch entirely. Important because this
// runs on every logEvent call in the hot path.
export const shouldSample = (event: LoggedEvent, rate: number): boolean => {
  if (rate >= 1) return true;
  return event.eventType === 'error' || event.success === false || Math.random() < rate;
};
